import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UrlWaitResolver implements Resolve<null> {
  constructor(protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<null> {
    await this.unfinishedHttpMethodsService.waitByUrl(state.url);
    return of(null).toPromise();
  }
}
